export default __webpack_public_path__ + "static/media/product.7c5f6838.png";